import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { useUser } from "contexts/UserContext";
import queryOrchidPro from "services/queryOrchidPro";
import { useTeamContext } from "contexts/group-practice-context/TeamContext";

export const OrchidProContext = createContext<{
  orchidPro: OrchidPro | undefined;
  setOrchidPro: (arg: OrchidPro | undefined) => void;
}>({
  orchidPro: undefined,
  setOrchidPro: () => null,
});

type Props = {
  children: ReactNode;
};
export const OrchidProContextProvider = ({ children }: Props) => {
  const { user } = useUser();
  const [orchidPro, setOrchidPro] = useState<OrchidPro | undefined>();
  const { practiceOwnerOrchidUserId } = useTeamContext();

  // get orchid pro on init
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (!user) {
      return;
    }
    queryOrchidPro(practiceOwnerOrchidUserId)
      .then((res) => {
        if (signal.aborted) return;
        setOrchidPro(res);
      })
      .catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      controller.abort();
    };
  }, [user, practiceOwnerOrchidUserId]);

  return (
    <OrchidProContext.Provider
      value={{
        orchidPro,
        setOrchidPro,
      }}
      children={children}
    />
  );
};

export const useOrchidPro = () => useContext(OrchidProContext);
